import _ from 'lodash';
import { createSelector } from 'reselect';
import { getModules, getCurrentModuleSlug } from './core';
import { getLocale } from './preferences';

const getModuleSlugToModuleMap = createSelector(getModules, modules =>
  _.keyBy(modules, m => m.acf?.chapter_number || m.slug)
);

const getCurrentModule = createSelector(
  getModuleSlugToModuleMap,
  getCurrentModuleSlug,
  (slugToModuleMap, moduleSlug) => slugToModuleMap[moduleSlug]
);

const getLearnModulesForCurrentLocale = createSelector(
  getModules,
  getLocale,
  (modules, locale) => {
    const filtered = modules.filter(m => m.languageId === locale || m.lang === locale);
    // If filtering kills everything, fall back to showing all modules so the user isn't stuck
    return filtered.length > 0 ? filtered : modules;
  }
);

const getDischargeModuleForCurrentLocale = createSelector(
  getModules,
  getLocale,
  (modules, locale) =>
    _.find(modules, m => m.isDischarge && (m.languageId === locale || m.lang === locale)) || 
    _.find(modules, m => m.isDischarge) // Fallback to first discharge module found
);

export {
  getModuleSlugToModuleMap,
  getCurrentModule,
  getLearnModulesForCurrentLocale,
  getDischargeModuleForCurrentLocale
};
